import './ProspectStatsStrip.css';

export default function ProspectStatsStrip({ stats, loading, activeFilter, onTileClick }) {
  const s = stats || {};
  const perStage = s.perStage || {};

  const tiles = [
    { key: 'total',     icon: '📋', label: 'Total Prospects',    value: s.total ?? 0,     filterKey: null },
    { key: 'stage1',    icon: '📄', label: 'Prelim Review',      value: perStage.PRELIMINARY_REVIEW ?? 0,          filterKey: 'PRELIMINARY_REVIEW' },
    { key: 'stage2',    icon: '💬', label: 'Initial Discussion', value: perStage.INITIAL_REVIEW_DISCUSSION ?? 0,   filterKey: 'INITIAL_REVIEW_DISCUSSION' },
    { key: 'stage3',    icon: '📁', label: 'Doc Collection',     value: perStage.DOCUMENT_COLLECTION ?? 0,         filterKey: 'DOCUMENT_COLLECTION' },
    { key: 'strategy',  icon: '📊', label: 'Strategy',           value: (perStage.FINAL_WEALTH_STRATEGY ?? 0) + (perStage.FINAL_STRATEGY_DISCUSSION ?? 0), filterKey: 'STRATEGY' },
    { key: 'execution', icon: '⚙️', label: 'Execution',          value: perStage.EXECUTION ?? 0,                   filterKey: 'EXECUTION' },
    { key: 'stalled',   icon: '⏰', label: 'Stalled >30d',       value: s.stalled ?? 0,   filterKey: 'STALLED',  urgent: (s.stalled ?? 0) > 0 },
  ];

  function handleTileClick(tile) {
    if (!tile.filterKey || !onTileClick) return;
    onTileClick(activeFilter === tile.filterKey ? 'ALL' : tile.filterKey);
  }

  return (
    <div className="pss__strip">
      {tiles.map(tile => {
        const isFilterable = !!tile.filterKey && !!onTileClick;
        const isActive = isFilterable && activeFilter === tile.filterKey;
        const isUrgent = !!tile.urgent && !isActive;

        return (
          <div
            key={tile.key}
            className={[
              'pss__tile',
              isUrgent      ? 'pss__tile--urgent'     : '',
              loading       ? 'pss__tile--loading'    : '',
              isFilterable  ? 'pss__tile--filterable' : '',
              isActive      ? 'pss__tile--active'     : '',
            ].filter(Boolean).join(' ')}
            onClick={() => handleTileClick(tile)}
            title={isFilterable ? (isActive ? 'Click to clear filter' : `Filter to ${tile.label}`) : undefined}
          >
            {isFilterable && (
              <span className={`pss__filter-badge ${isActive ? 'pss__filter-badge--active' : ''}`}>
                {isActive ? '✕' : (
                  <svg viewBox="0 0 10 10" width="9" height="9" fill="currentColor">
                    <path d="M0 1.5h10L6.5 5.5v3.5l-3-1V5.5Z"/>
                  </svg>
                )}
              </span>
            )}
            <span className="pss__tile-icon">{tile.icon}</span>
            <span className="pss__tile-value">{loading ? '—' : tile.value}</span>
            <span className="pss__tile-label">{tile.label}</span>
          </div>
        );
      })}
    </div>
  );
}
